import { Type } from '@sinclair/typebox';
import type { Static } from '@sinclair/typebox';

/**
 * Тип и схема событий активности LLM-агентов (используются для WebSocket-канала).
 */
export const LlmActivityEventSchema = Type.Object({
  type: Type.Union([
    Type.Literal('run_started'),
    Type.Literal('run_step'),
    Type.Literal('run_finished'),
    Type.Literal('run_error'),
  ]),
  agent_id: Type.Integer(),
  agent_name: Type.String(),
  run_id: Type.Integer(),
  timestamp: Type.String({ format: 'date-time' }),
  message: Type.Optional(Type.String()),
  step: Type.Optional(
    Type.Object({
      kind: Type.String(),
      summary: Type.Optional(Type.String()),
    })
  ),
  status: Type.Optional(
    Type.Union([Type.Literal('success'), Type.Literal('error'), Type.Literal('max_iter')])
  ),
  error: Type.Optional(Type.String()),
});

export type LlmActivityEvent = Static<typeof LlmActivityEventSchema>;
